import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadDetailsComponent } from './load-details.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';
import { SidemenuModule } from '../sidemenu/sidemenu.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadAddEditComponent } from './load-add-edit/load-add-edit.component';
import { RouterModule } from '@angular/router';
import { BreaksComponent } from './breaks/breaks.component';

@NgModule({
  declarations: [LoadDetailsComponent, LoadAddEditComponent, BreaksComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    FooterModule,
    SidemenuModule,
    RouterModule.forChild([
      {
        path: "",
        component: LoadDetailsComponent
      },
      {
        path: "add-edit/loadDetails/:isEditOrAdd",
        component: LoadAddEditComponent
      }
    ])
  ]
})
export class LoadDetailsModule { }
